import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreDots = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M14.1875 6.5C14.1875 5.675 13.5125 5 12.6875 5C11.8625 5 11.1875 5.675 11.1875 6.5C11.1875 7.325 11.8625 8 12.6875 8C13.5125 8 14.1875 7.325 14.1875 6.5ZM14.1875 17.5C14.1875 16.675 13.5125 16 12.6875 16C11.8625 16 11.1875 16.675 11.1875 17.5C11.1875 18.325 11.8625 19 12.6875 19C13.5125 19 14.1875 18.325 14.1875 17.5ZM14.1875 12C14.1875 11.175 13.5125 10.5 12.6875 10.5C11.8625 10.5 11.1875 11.175 11.1875 12C11.1875 12.825 11.8625 13.5 12.6875 13.5C13.5125 13.5 14.1875 12.825 14.1875 12Z" })]
});
const ForwardRef = forwardRef(SvgMoreDots);
export default ForwardRef;
